import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.subjects');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-subjects',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.subjects/view.scss */
:host {
  display: block;
  width: 100%;
}

.subject-admin-page {
  position: relative;
}

.subject-hero {
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(99, 102, 241, 0.18), transparent 26%), radial-gradient(circle at left center, rgba(56, 189, 248, 0.1), transparent 24%), linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(244, 247, 255, 0.96));
  box-shadow: 0 24px 60px rgba(79, 70, 229, 0.1);
}

.subject-hero__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
}

.subject-hero__eyebrow {
  color: #6366f1;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.subject-hero__title {
  margin-top: 0.7rem;
  color: #0f172a;
  font-size: 30px;
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.subject-hero__desc {
  max-width: 52rem;
  margin-top: 0.85rem;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.subject-hero__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;
  margin-top: 1.5rem;
}

.subject-hero-stat {
  padding: 0.9rem 1rem;
  border-radius: 18px;
  border: 1px solid rgba(224, 231, 255, 0.95);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.subject-hero-stat span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.subject-hero-stat strong {
  display: block;
  margin-top: 0.32rem;
  color: #172554;
  font-size: 18px;
  font-weight: 800;
}

.subject-toolbar {
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.05);
}

.subject-mobile-card {
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06);
}

.subject-table-shell {
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.06);
}

.subject-create-fab {
  position: fixed;
  overflow: visible;
  box-shadow: 0 18px 40px rgba(79, 70, 229, 0.28);
  transition: transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
}

.subject-create-fab::after {
  content: "";
  position: absolute;
  inset: -8px;
  z-index: -1;
  border-radius: 9999px;
  background: rgba(99, 102, 241, 0.18);
  animation: subjectFabPulse 2.6s ease-in-out infinite;
}

.subject-create-fab:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 22px 46px rgba(79, 70, 229, 0.34);
}

.subject-create-fab--desktop {
  position: relative;
  right: auto;
  bottom: auto;
  z-index: auto;
  border-radius: 18px;
}

.subject-create-fab--desktop::after {
  border-radius: 22px;
}

.subject-create-fab:active {
  transform: scale(0.94) rotate(8deg);
}

.subject-create-fab--active {
  background: #4338ca;
}

.subject-create-fab--active .subject-create-fab__icon {
  transform: rotate(135deg) scale(1.05);
}

.subject-create-fab__icon {
  transition: transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.subject-create-backdrop {
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.18), rgba(15, 23, 42, 0.42));
  backdrop-filter: blur(8px);
  animation: subjectBackdropIn 180ms ease-out both;
}

.subject-create-dialog {
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.24);
  animation: subjectDialogIn 260ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.subject-create-header {
  background: radial-gradient(circle at top right, rgba(99, 102, 241, 0.16), transparent 38%), linear-gradient(180deg, rgba(248, 250, 252, 0.96), rgba(255, 255, 255, 0.98));
}

.subject-create-section {
  border: 1px solid rgba(226, 232, 240, 0.92);
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96));
  padding: 14px;
}

.subject-create-section__title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6366f1;
}

.subject-create-note {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

@keyframes subjectFabPulse {
  0%, 100% {
    transform: scale(0.92);
    opacity: 0.55;
  }
  50% {
    transform: scale(1.08);
    opacity: 0.12;
  }
}
@keyframes subjectBackdropIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes subjectDialogIn {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .subject-create-fab,
  .subject-create-fab__icon,
  .subject-create-backdrop,
  .subject-create-dialog,
  .subject-create-fab::after {
    animation: none;
    transition: none;
  }
}
@media (max-width: 767px) {
  .subject-toolbar {
    border-radius: 20px;
  }
}
/* Compact admin presentation */
.subject-admin-page {
  width: min(100%, 1280px);
  padding: 20px;
}

.subject-hero {
  overflow: visible;
  margin-bottom: 14px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.subject-hero__row {
  min-height: 36px;
  align-items: center;
}

.subject-hero__title {
  margin: 0;
  color: #111827;
  font-size: 22px;
  font-weight: 750;
}

.subject-create-fab {
  border-radius: 8px;
  box-shadow: none;
  transition: background-color 120ms ease;
}

.subject-create-fab::after {
  display: none;
}

.subject-create-fab--desktop {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  background: #4f46e5;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.subject-create-fab:hover {
  transform: none;
  background: #4338ca;
  box-shadow: none;
}

.subject-toolbar {
  margin-bottom: 14px;
  padding: 12px;
  border-radius: 10px;
  box-shadow: none;
}

.subject-toolbar input,
.subject-toolbar select,
.subject-toolbar button {
  min-height: 38px;
  border-radius: 8px;
  box-shadow: none;
}

.subject-table-shell {
  border-radius: 12px;
  box-shadow: none;
}

.subject-table-shell thead {
  background: #f8fafc;
}

.subject-table-shell tbody tr:hover {
  background: #f8fafc;
}

.subject-hero__heading {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.subject-hero__count {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.subject-table-action {
  display: inline-flex;
  flex: 0 0 auto;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.subject-table-action:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.subject-table-action--copy {
  border-color: #c7d2fe;
  color: #4f46e5;
}

.subject-mobile-card {
  border-radius: 10px;
  box-shadow: none;
}

.subject-create-backdrop {
  background: rgba(15, 23, 42, 0.38);
  backdrop-filter: none;
}

.subject-create-dialog {
  border-radius: 12px;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.16);
}

.subject-create-header {
  border-bottom: 1px solid #eef0f3;
  background: #fff;
}

.subject-create-section {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: #fff;
}

.subject-create-section + .subject-create-section {
  padding-top: 14px;
  border-top: 1px solid #eef0f3;
}

.subject-create-section__title {
  color: #374151;
  font-size: 12px;
  letter-spacing: 0;
  text-transform: none;
}

.subject-create-dialog input,
.subject-create-dialog select,
.subject-create-dialog button {
  border-radius: 8px;
}

@media (max-width: 767px) {
  .subject-admin-page {
    padding: 16px 16px 88px;
  }
  .subject-hero {
    display: none;
  }
  .subject-toolbar {
    border-radius: 10px;
  }
  .subject-create-fab:not(.subject-create-fab--desktop) {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #4f46e5;
    box-shadow: 0 8px 18px rgba(79, 70, 229, 0.22);
  }
}
.subject-status-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 10px;
  padding: 4px;
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f8fafc;
  scrollbar-width: none;
}

.subject-status-tabs::-webkit-scrollbar {
  display: none;
}

.subject-status-tab {
  display: inline-flex;
  min-width: 88px;
  min-height: 36px;
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
  white-space: nowrap;
  transition: color 120ms ease, background-color 120ms ease, box-shadow 120ms ease;
}

.subject-status-tab strong {
  min-width: 22px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #475569;
  font-size: 11px;
  font-weight: 750;
  line-height: 1.45;
}

.subject-status-tab.is-loading {
  cursor: wait;
}

.subject-status-tab__spinner {
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
  border: 2px solid #c7d2fe;
  border-top-color: #4f46e5;
  border-radius: 999px;
  animation: subjectDrawerSpin 650ms linear infinite;
}

.subject-status-tab:hover {
  color: #334155;
  background: #fff;
}

.subject-status-tab.is-active {
  background: #fff;
  color: #4338ca;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.subject-status-tab.is-active strong {
  background: #eef2ff;
  color: #4f46e5;
}

.subject-table-scroll {
  max-height: calc(100vh - 310px);
  overflow: auto;
}

.subject-table-shell {
  position: relative;
}

.subject-table-loading {
  position: absolute;
  inset: 33px 0 0;
  z-index: 3;
  display: flex;
  min-height: 130px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  background: rgba(255, 255, 255, 0.78);
  color: #475569;
  font-size: 12px;
  font-weight: 650;
  backdrop-filter: blur(1px);
}

.subject-list-spinner {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  border: 2px solid #dbe3ef;
  border-top-color: #4f46e5;
  border-radius: 999px;
  animation: subjectDrawerSpin 650ms linear infinite;
}

.subject-mobile-loading {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 1px solid #c7d2fe;
  border-radius: 9px;
  background: #f5f7ff;
  color: #475569;
  font-size: 12px;
  font-weight: 650;
}

.subject-mobile-list .subject-mobile-card {
  transition: opacity 120ms ease;
}

.subject-mobile-list.is-loading .subject-mobile-card {
  pointer-events: none;
  opacity: 0.44;
}

.subject-table-scroll thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

.subject-table-row {
  cursor: pointer;
  outline: none;
  transition: background-color 100ms ease;
}

.subject-table-row:focus-visible {
  box-shadow: inset 3px 0 #6366f1;
  background: #f5f7ff;
}

.subject-table-row.is-selected {
  background: #eef2ff;
  box-shadow: inset 3px 0 #6366f1;
}

.subject-drawer-layer {
  position: fixed;
  inset: 0;
  z-index: 50;
}

.subject-drawer-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.32);
  animation: subjectDrawerBackdropIn 160ms ease-out both;
}

.subject-drawer {
  position: absolute;
  inset: 0 0 0 auto;
  display: flex;
  width: min(440px, 100%);
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: -18px 0 50px rgba(15, 23, 42, 0.14);
  animation: subjectDrawerIn 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.subject-drawer__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 22px 18px;
  border-bottom: 1px solid #e5e7eb;
}

.subject-drawer__eyebrow {
  margin-bottom: 7px;
  color: #6366f1;
  font-size: 11px;
  font-weight: 750;
}

.subject-drawer__heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.subject-drawer__heading h2 {
  overflow: hidden;
  margin: 0;
  color: #111827;
  font-size: 20px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subject-drawer__header p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 13px;
}

.subject-drawer__close {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 20px;
  line-height: 1;
}

.subject-drawer__close:hover {
  background: #f8fafc;
  color: #334155;
}

.subject-drawer__body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px 22px;
}

.subject-drawer__loading {
  display: flex;
  min-height: 220px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #64748b;
  font-size: 12px;
}

.subject-drawer__loading span {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top-color: #6366f1;
  border-radius: 999px;
  animation: subjectDrawerSpin 700ms linear infinite;
}

.subject-drawer-section {
  padding-bottom: 20px;
  border-bottom: 1px solid #eef0f3;
}

.subject-drawer-section:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.subject-drawer-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.subject-drawer-section__title {
  color: #334155;
  font-size: 12px;
  font-weight: 750;
}

.subject-drawer-section__count {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 650;
}

.subject-drawer-info {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 12px 0 0;
}

.subject-drawer-info > div {
  padding: 11px 12px;
  border-radius: 8px;
  background: #f8fafc;
}

.subject-drawer-info dt {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 650;
}

.subject-drawer-info dd {
  margin: 4px 0 0;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
}

.subject-drawer-copy {
  padding: 5px 8px;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  background: #fff;
  color: #4f46e5;
  font-size: 11px;
  font-weight: 700;
}

.subject-drawer-copy:hover {
  background: #eef2ff;
}

.subject-drawer-url {
  margin-top: 10px;
  padding: 10px 11px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 10px;
  line-height: 1.55;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subject-drawer-forms {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.subject-drawer-form {
  padding: 11px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  background: #fff;
}

.subject-drawer-form__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.subject-drawer-form__top span {
  display: block;
  margin-bottom: 3px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.subject-drawer-form__top h3 {
  overflow: hidden;
  margin: 0;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subject-drawer-form__top strong {
  flex: 0 0 auto;
  padding: 3px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 750;
}

.subject-drawer-form__progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.subject-drawer-form__progress > div {
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}

.subject-drawer-form__progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #6366f1;
}

.subject-drawer-form__progress small {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.subject-drawer-form__stages {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: 9px;
}

.subject-drawer-form__stages > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  margin: 0;
  border: 1px solid #eef0f3;
  border-radius: 7px;
  padding: 5px 6px;
  color: #64748b;
  font-size: 9px;
  font-weight: 700;
}

.subject-drawer-form__stages strong {
  border-radius: 999px;
  padding: 2px 4px;
  font-size: 8px;
  font-weight: 800;
}

.subject-drawer-error {
  margin-top: 10px;
  padding: 10px;
  border-radius: 8px;
  background: #fff1f2;
  color: #be123c;
  font-size: 11px;
}

.subject-drawer__footer {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 8px;
  padding: 14px 22px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.subject-drawer__secondary,
.subject-drawer__primary {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.subject-drawer__secondary {
  border: 1px solid #dbe1e8;
  background: #fff;
  color: #64748b;
}

.subject-drawer__primary {
  border: 1px solid #4f46e5;
  background: #4f46e5;
  color: #fff;
}

.subject-drawer__primary:hover {
  background: #4338ca;
}

@keyframes subjectDrawerBackdropIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes subjectDrawerIn {
  from {
    transform: translateX(24px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes subjectDrawerSpin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 767px) {
  .subject-status-tabs {
    margin: 0 -16px 10px;
    padding: 4px 16px;
    border-width: 1px 0;
    border-radius: 0;
  }
  .subject-status-tab {
    min-width: 82px;
    flex: 0 0 auto;
  }
  .subject-drawer {
    width: 100%;
    border-left: 0;
  }
  .subject-drawer__header {
    padding: 18px 18px 15px;
  }
  .subject-drawer__body {
    padding: 18px;
  }
  .subject-drawer__footer {
    padding: 12px 18px max(12px, env(safe-area-inset-bottom));
  }
}
@media (prefers-reduced-motion: reduce) {
  .subject-status-tab,
  .subject-table-row,
  .subject-mobile-card,
  .subject-status-tab__spinner,
  .subject-list-spinner,
  .subject-drawer-backdrop,
  .subject-drawer,
  .subject-drawer__loading span {
    animation: none;
    transition: none;
  }
}
/* Unified admin visual hierarchy */
.subject-admin-page {
  margin: 0 auto;
  padding: 24px 28px 40px;
  color: var(--admin-text, #334155);
}

.subject-hero {
  overflow: visible;
  margin-bottom: 16px;
  padding: 2px 2px 6px;
  background: transparent;
  box-shadow: none;
}

.subject-hero__eyebrow {
  color: var(--admin-primary, #4f46e5);
  letter-spacing: 0.08em;
}

.subject-hero__title {
  margin-top: 5px;
  color: var(--admin-text-strong, #111827);
  font-size: 24px;
}

.subject-hero__desc {
  margin-top: 7px;
  color: var(--admin-text-muted, #64748b);
  line-height: 1.55;
}

.subject-hero-stat {
  border-color: var(--admin-border, #dce2ea);
  border-radius: 10px;
  background: var(--admin-surface, #fff);
  box-shadow: none;
}

.subject-create-fab--desktop {
  border-radius: 9px;
  background: var(--admin-primary, #4f46e5);
  box-shadow: 0 7px 16px rgba(79, 70, 229, 0.2);
}

.subject-create-fab--desktop::after {
  display: none;
}

.subject-status-tabs {
  margin-bottom: 12px;
  padding: 4px;
  border: 1px solid var(--admin-border, #dce2ea);
  border-radius: 12px;
  background: var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.subject-status-tab {
  min-height: 38px;
  border-radius: 8px;
  color: var(--admin-text-muted, #64748b);
}

.subject-status-tab.is-active {
  background: var(--admin-primary-soft, #eef2ff);
  box-shadow: inset 0 0 0 1px #c7d2fe;
  color: var(--admin-primary-dark, #3730a3);
}

.subject-status-tab[data-status=completed].is-active {
  background: var(--admin-success-soft, #ecfdf5);
  box-shadow: inset 0 0 0 1px #a7f3d0;
  color: var(--admin-success, #047857);
}

.subject-status-tab[data-status=in_progress].is-active {
  background: var(--admin-warning-soft, #fffbeb);
  box-shadow: inset 0 0 0 1px #fde68a;
  color: var(--admin-warning, #b45309);
}

.subject-status-tab[data-status=expired].is-active {
  background: var(--admin-danger-soft, #fff1f2);
  box-shadow: inset 0 0 0 1px #fecdd3;
  color: var(--admin-danger, #be123c);
}

.subject-status-tab[data-status=pending].is-active {
  background: var(--admin-surface-subtle, #f8fafc);
  box-shadow: inset 0 0 0 1px #cbd5e1;
  color: var(--admin-text, #334155);
}

.subject-toolbar {
  margin-bottom: 12px;
  border: 1px solid var(--admin-border, #dce2ea);
  border-radius: 12px;
  background: linear-gradient(135deg, var(--admin-primary-soft, #eef2ff), rgba(255, 255, 255, 0) 34%), var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.subject-table-shell,
.subject-mobile-card {
  border-color: var(--admin-border, #dce2ea);
  border-radius: 12px;
  background: var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.subject-table-shell thead {
  background: var(--admin-surface-subtle, #f8fafc);
}

.subject-table-row:hover,
.subject-table-row.is-selected {
  background: var(--admin-primary-soft, #eef2ff);
}

.subject-drawer__header,
.subject-drawer__footer {
  border-color: var(--admin-border, #dce2ea);
  background: var(--admin-surface-subtle, #f8fafc);
}

@media (max-width: 767px) {
  .subject-admin-page {
    padding: 16px 16px 32px;
  }
  .subject-status-tabs {
    margin: 0 -16px 10px;
    border-radius: 0;
    box-shadow: none;
  }
}`],
})
export class PageAdminSubjectsComponent implements OnInit {
    public rows: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 10;
    public q: string = '';
    public statusFilter: string = '';
    public sortOption: string = 'created_desc';
    public loading: boolean = false;
    public statusTabs: any[] = [
        { value: '', label: '전체' },
        { value: 'pending', label: '미응답' },
        { value: 'in_progress', label: '진행중' },
        { value: 'completed', label: '완료' },
        { value: 'expired', label: '만료' }
    ];
    public statusCounts: any = {
        total: 0,
        pending: 0,
        in_progress: 0,
        completed: 0,
        expired: 0
    };
    private statusCountsLoaded: boolean = false;
    private statusCountsLoading: boolean = false;
    private loadRequestId: number = 0;

    public showCreate: boolean = false;
    public creating: boolean = false;
    public newSubject: any = { code: '', name: '', gender: 'O', birth: '', memo: '', expires_days: 30 };

    public showIssued: boolean = false;
    public issued: any = null;
    public showQuickDetail: boolean = false;
    public quickLoading: boolean = false;
    public selectedSubject: any = null;
    public quickDetail: any = null;

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) {
            return data.data;
        }
        return data || {};
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const requestId = ++this.loadRequestId;
        this.loading = true;
        await this.service.render();

        const params: any = { page: this.page, dump: this.dump, sort: this.sortOption };
        if (this.q) params.q = this.q;
        if (this.statusFilter) params.status = this.statusFilter;
        params.include_counts = this.statusCountsLoaded ? 0 : 1;

        const { code, data } = await wiz.call("list", params);
        if (requestId !== this.loadRequestId) return;

        if (code === 200 && data) {
            const payload = this.payload(data);
            this.rows = payload.rows || [];
            this.total = payload.total || 0;
            if (payload.counts) {
                this.statusCounts = payload.counts;
                this.statusCountsLoaded = true;
            }
        }
        this.loading = false;
        await this.service.render();

        if (!this.statusCountsLoaded) {
            await this.ensureStatusCounts();
        }
    }

    private async ensureStatusCounts() {
        if (this.statusCountsLoaded || this.statusCountsLoading) return;
        this.statusCountsLoading = true;

        const statuses = ['pending', 'in_progress', 'completed', 'expired'];
        const counts: any = { total: 0 };
        const requests = statuses.map((status) => wiz.call("list", {
            page: 1,
            dump: 1,
            status: status,
            include_counts: 0
        }));
        const responses: any[] = await Promise.all(requests);
        const success = responses.every((response: any) => response && response.code === 200);

        if (success) {
            statuses.forEach((status, index) => {
                const payload = this.payload(responses[index].data);
                counts[status] = Number(payload.total || 0);
                counts.total += counts[status];
            });
            this.statusCounts = counts;
            this.statusCountsLoaded = true;
        }
        this.statusCountsLoading = false;
        await this.service.render();
    }

    private invalidateStatusCounts() {
        this.statusCountsLoaded = false;
    }

    public async search() {
        this.page = 1;
        await this.closeQuickDetail(false);
        await this.load();
    }

    public async setSort(value: string) {
        const allowed = ['created_desc', 'created_asc', 'name_asc', 'code_asc', 'expires_at_asc'];
        this.sortOption = allowed.includes(value) ? value : 'created_desc';
        this.page = 1;
        await this.closeQuickDetail(false);
        await this.load();
    }

    public async setStatus(status: string) {
        if (this.statusFilter === status) return;
        this.statusFilter = status;
        this.page = 1;
        await this.closeQuickDetail(false);
        await this.load();
    }

    public statusCount(status: string): number {
        return Number(this.statusCounts[status || 'total'] || 0);
    }

    public async setPage(p: number) {
        if (p < 1) return;
        if (p > this.totalPages()) return;
        this.page = p;
        await this.closeQuickDetail(false);
        await this.load();
    }

    public totalPages(): number {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }

    public pageList(): number[] {
        const tp = this.totalPages();
        const start = Math.max(1, this.page - 2);
        const end = Math.min(tp, start + 4);
        const arr: number[] = [];
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
    }

    public async openCreate() {
        this.newSubject = { code: '', name: '', gender: 'O', birth: '', memo: '', expires_days: 30 };
        this.showCreate = true;
        await this.service.render();
    }

    private formatBirth(value: any): string {
        const digits = String(value || '').replace(/[^0-9]/g, '').slice(0, 8);
        if (digits.length <= 4) return digits;
        if (digits.length <= 6) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
        return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6)}`;
    }

    private isValidBirth(value: any): boolean {
        const birth = String(value || '');
        const match = birth.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return false;

        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        const parsed = new Date(year, month - 1, day);
        return parsed.getFullYear() === year
            && parsed.getMonth() === month - 1
            && parsed.getDate() === day;
    }

    public onBirthInput(value: any) {
        this.newSubject.birth = this.formatBirth(value);
    }

    public async closeCreate() {
        this.showCreate = false;
        await this.service.render();
    }

    public async submitCreate() {
        if (!this.newSubject.code) {
            alert('식별번호(코드)를 입력해주세요.');
            return;
        }
        const name = String(this.newSubject.name || '').trim();
        if (!name) {
            alert('이름을 입력해주세요.');
            return;
        }
        this.newSubject.name = name;
        const birth = this.formatBirth(this.newSubject.birth);
        if (!birth) {
            alert('생년월일을 입력해주세요.');
            return;
        }
        if (!this.isValidBirth(birth)) {
            alert('생년월일을 YYYY-MM-DD 형식으로 정확히 입력해주세요.');
            return;
        }
        this.newSubject.birth = birth;
        this.creating = true;
        await this.service.render();
        const { code, data } = await wiz.call("create", this.newSubject);
        this.creating = false;
        if (code === 200) {
            const payload = this.payload(data);
            this.showCreate = false;
            this.issued = payload;
            this.showIssued = true;
            this.invalidateStatusCounts();
            await this.load();
        } else {
            alert((data && data.message) || '생성 실패');
            await this.service.render();
        }
    }

    public async closeIssued() {
        this.showIssued = false;
        this.issued = null;
        await this.service.render();
    }

    public async openQuickDetail(row: any, event?: any) {
        if (event) event.stopPropagation();
        this.selectedSubject = row;
        this.quickDetail = row;
        this.showQuickDetail = true;
        this.quickLoading = true;
        await this.service.render();

        const subjectApi = (wiz as any).app("page.admin.subjects.item");
        const { code, data } = await subjectApi.call("get", { id: row.id });
        if (code === 200) {
            this.quickDetail = this.payload(data);
        } else {
            alert((data && data.message) || '대상자 정보를 불러오지 못했습니다.');
            this.showQuickDetail = false;
            this.selectedSubject = null;
            this.quickDetail = null;
        }
        this.quickLoading = false;
        await this.service.render();
    }

    public async closeQuickDetail(render: boolean = true) {
        this.showQuickDetail = false;
        this.quickLoading = false;
        this.selectedSubject = null;
        this.quickDetail = null;
        if (render) await this.service.render();
    }

    public surveyUrl(token: string): string {
        if (!token) {
            return '';
        }
        return location.origin + '/s/' + token;
    }

    public async copyUrl(token: string) {
        if (!token) {
            alert('설문 URL이 아직 생성되지 않았습니다.');
            return;
        }
        const url = this.surveyUrl(token);
        try {
            await navigator.clipboard.writeText(url);
            alert('URL이 복사되었습니다.\n' + url);
        } catch (e) {
            prompt('URL을 복사하세요.', url);
        }
    }

    public async del(row: any) {
        if (!confirm(`대상자 ${row.code}를 삭제하시겠습니까? 응답 데이터도 함께 삭제됩니다.`)) return;
        const { code, data } = await wiz.call("delete", { id: row.id });
        if (code === 200) {
            if (this.selectedSubject && this.selectedSubject.id === row.id) {
                await this.closeQuickDetail(false);
            }
            this.invalidateStatusCounts();
            await this.load();
        } else {
            alert((data && data.message) || '삭제 실패');
        }
    }

    public genderLabel(value: string): string {
        if (value === 'M') return '남';
        if (value === 'F') return '여';
        return '-';
    }

    public formatDate(value: any): string {
        if (!value) return '-';
        return String(value).slice(0, 10);
    }

    public statusBadge(status: string): string {
        const map: any = {
            'pending':     'bg-slate-100 text-slate-700',
            'in_progress': 'bg-amber-100 text-amber-700',
            'completed':   'bg-emerald-100 text-emerald-700',
            'expired':     'bg-rose-100 text-rose-700'
        };
        return map[status] || 'bg-slate-100 text-slate-700';
    }

    public statusLabel(status: string): string {
        const map: any = {
            'pending':     '미응답',
            'in_progress': '진행중',
            'completed':   '완료',
            'expired':     '만료'
        };
        return map[status] || status;
    }

    public formAudienceLabel(form: any): string {
        return form && form.audience === 'admin_only' ? '관리자 전용' : '대상자 · 관리자';
    }

    public formTitle(form: any): string {
        if (form && form.code === 'original_survey') {
            return '한의 검진 설문(CRF)';
        }
        return (form && form.title) || '설문';
    }

    public formStatusBadge(status: string): string {
        const map: any = {
            'pending': 'bg-slate-100 text-slate-700',
            'in_progress': 'bg-amber-100 text-amber-700',
            'admin_pending': 'bg-indigo-100 text-indigo-700',
            'submitted': 'bg-emerald-100 text-emerald-700'
        };
        return map[status] || map.pending;
    }

    public formStatusLabel(status: string): string {
        const map: any = {
            'pending': '미작성',
            'in_progress': '작성 중',
            'admin_pending': '관리자 기록 대기',
            'submitted': '완료'
        };
        return map[status] || '미작성';
    }
}

export default PageAdminSubjectsComponent;